import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import ErrorBoundary from './components/common/ErrorBoundary';

import Router from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Stack } from '@mui/material';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Tncbanner from './components/tncbanner/Tncbanner';


function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Prevent browser from restoring previous scroll position on back/forward.
    if ('scrollRestoration' in window.history) {
      const previous = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
      return () => {
        window.history.scrollRestoration = previous;
      };
    }
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.key, location.pathname, location.search, location.hash]);

  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Stack sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
          <AuthProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Header></Header>
              
              <Router />
              <Footer></Footer>
            </BrowserRouter>
          </AuthProvider>
        </Stack>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
